// extracted by mini-css-extract-plugin
module.exports = {"invalidLicense":"styles_invalidLicense__qLho2"};